































































import Banner from "@/components/Banner.vue";
import Component from "vue-class-component";
import Vue from "vue";
import Layout from "@/components/Layout.vue";
import { namespace } from "vuex-class";

const Animations = namespace("animations");

@Component({
  components: {
    Layout,
    Banner: Banner,
  },
})
export default class Home extends Vue {
  @Animations.State
  private bannerDisplayed!: boolean;
  @Animations.Mutation
  private setBannerDisplayed!: (value: boolean) => void;
  @Animations.State
  private exceptShown!: boolean;
  @Animations.Mutation
  private setExceptShown!: (value: boolean) => void;
  @Animations.State
  private closingLineShown!: boolean;
  @Animations.Mutation
  private setClosingLineShown!: (value: boolean) => void;

  private excerptShown() {
    this.setExceptShown(true);
  }

  private onBannerDisplay() {
    this.setBannerDisplayed(true);
  }
}
